import { EVENT } from "@/constants/event";
import { LOCAL_STORAGE_KEY } from "@/constants/localStorageKey";
import { PIN_OPEN_TYPE } from "@/constants/pinOpenType";
import {
  getMe,
  getUserConfigAiWatermark,
  getUserPermissions,
} from "@/services";
import { setTrackerUser } from "@/tracker";
import { gdSlsReportError, setGdSlsRumUser } from "@/utils/gdSlsRum";
import { set as lodashSet } from "lodash";

export const checkPageSetting = (user) => {
  const pageSetting = user?.user_config?.configs;
  if (pageSetting) {
    const pageSettingStr = JSON.stringify(pageSetting);
    if (
      pageSettingStr !==
      window.localStorage.getItem(LOCAL_STORAGE_KEY.HUABAN_PAGE_SETTING)
    ) {
      window.localStorage.setItem(
        LOCAL_STORAGE_KEY.HUABAN_PAGE_SETTING,
        pageSettingStr
      );
      window.dispatchEvent(new Event(EVENT.PAGE_SETTING_CHANGE));
    }

    const pinOpenType = pageSetting?.pinOpenType || PIN_OPEN_TYPE.MODAL;
    const showPinDesc = pageSetting?.showPinDesc;
    const showPinUserInfo = pageSetting?.showPinUserInfo;

    return {
      pinOpenType,
      showPinDesc,
      showPinUserInfo,
    };
  }
};

export default function user(set) {
  return {
    /**
     * @type {IUser}
     */
    user: null,
    userReady: false,
    orgInfo: null,
    orgList: [],
    currentOrg: null,
    /**@type {Record<string, boolean>} */
    userPermissions: {},

    pinOpenType: PIN_OPEN_TYPE.MODAL,
    showPinDesc: undefined,
    showPinUserInfo: undefined,

    // 刷新用户信息，自动调用getMe接口
    async refreshUser() {
      const userResult = await getMe();

      // 接口出错不更新用户信息,上报记录错误
      if (userResult.err) {
        if (userResult.msg === "用户不存在") {
          // 用户不存在是登录失效，不做异常上报
          return;
        }
        gdSlsReportError(
          new Error(`update user error: ${userResult.msg || userResult.err}`)
        );
        return;
      }

      // 其他异常数据
      if (!userResult.user_id) {
        gdSlsReportError(new Error(`user info exception: ${userResult}`));
        return;
      }

      // 更新埋点用户信息
      setTrackerUser(userResult);
      // 判断用户是否保存了配置信息，如果有的话替换本地的配置信息
      const setting = checkPageSetting(userResult);

      set({
        user: userResult,
        userReady: true,
        pinCount: userResult.pin_count || 0,
        ...(setting || {}),
      });

      setGdSlsRumUser(userResult);

      return userResult;
    },
    setUser(user) {
      set({
        user: user,
        userReady: true,
      });

      try {
        setTrackerUser(user);
        checkPageSetting(user);
        setGdSlsRumUser(user);
      } catch (error) {
        gdSlsReportError(error);
      }
    },

    async refreshUserPermissions() {
      const userPermissions = await getUserPermissions();

      // 刷新用户权限
      set({
        userPermissions: userPermissions.reduce((prev, curr) => {
          prev[curr] = true;
          return prev;
        }, {}),
      });
    },

    async refreshUserConfigAiWatermark() {
      const result = await getUserConfigAiWatermark();
      set((state) => lodashSet(state.user, "configs.aiWatermark", result));
      return result;
    },
  };
}
